module.exports = __webpack_public_path__ + "static/media/featured-offer-medicaid-1.85ff2b8b.jpeg";